var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-items-list')],1),_c('v-flex',{staticClass:"ml-1",attrs:{"xs6":""}},[_c('v-mapping-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }